import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

export const CostPerViewField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const currency = watch(MarketplaceFormKeys.currency);

  return (
    <TextField
      placeholder="0.1"
      rightSection={t(currency)}
      help={t('Tooltip.Cost View Help')}
      title={t('TextForm.Cost per View')}
      name={MarketplaceFormKeys.costPerView}
      {...props}
    />
  );
};
